module.exports = __webpack_public_path__ + "img/dengji9.9a3036f4.png";